import { render, staticRenderFns } from "./questions-panel.vue?vue&type=template&id=711056b6&scoped=true&"
import script from "./questions-panel.vue?vue&type=script&lang=ts&"
export * from "./questions-panel.vue?vue&type=script&lang=ts&"
import style0 from "./questions-panel.vue?vue&type=style&index=0&id=711056b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711056b6",
  null
  
)

export default component.exports